export const multiSelectSeparator = '<<<<<->>>>>';
